import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("nl_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("nl_cart", JSON.stringify(items));
  }, [items]);

  // variant: { size, sizeLabel, unitPrice } — null for prerolls
  const addItem = (product, quantity = 1, variant = null) => {
    const size = variant?.size || null;
    const sizeLabel = variant?.sizeLabel || product.weight || "";
    const unitPrice = variant ? variant.unitPrice : product.price;
    const key = `${product.id}:${size || "default"}`;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) =>
          i.key === key ? { ...i, quantity: i.quantity + quantity } : i
        );
      }
      return [...prev, { key, product, size, sizeLabel, unitPrice, quantity }];
    });
  };

  const updateQty = (key, quantity) => {
    if (quantity <= 0) return removeItem(key);
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity } : i)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.unitPrice * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, count, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
}
